import * as React from "react"
const WorkOwlFullWigns:React.FC<any> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 1920 1080"
    {...props}
  >
    <style>{".st0{fill:#51db81}.st2{fill:#252e4f}.st5{fill:#edf7f4}"}</style>
    <path
      id="w_2"
      d="M1532 413.03a136.709 136.709 0 0 1-30.05 64.76c-11.24 3.9-26.86 8.9-45.8 13.74-88.19 22.61-158.31 20.11-160.62 20.07 39.76 3.05 83.57 4.19 130.77 2.01 22.87-1.04 44.79-2.79 65.64-5.07-9.87 12.89-24.91 31.57-44.69 52.75-36.9 39.43-88.25 93.32-168.51 129.14-21.57 9.61-53.69 21.73-95.3 29.36l-.42-.41c-10.08-9.88-13.03-24.8-7.88-37.95 20.05-51.14 23.46-105.13 8.49-152.99-2.92-9.35-6.59-18.71-10.98-27.97 65.09-6.3 138.4-18.29 217.17-39.76 52.18-14.2 99.63-30.63 142.18-47.68z"
      className="st0"
    />
    <g id="head">
      <ellipse
        cx={933.03}
        cy={375.91}
        className="st0"
        rx={221.31}
        ry={150.21}
      />
      <path
        id="Layer_5"
        d="M724.41 184.02s3.92 81.11 171.3 69.85 201.18 22.53 269.9-69.85c0 0 41.27 98.82-114.91 141.95s-387.82-5.64-326.29-141.95z"
        className="st0"
      />
    </g>
    <g id="bdy">
      <path
        id="Layer_14"
        d="M833.36 714.7s-25.47 3.38-64.13 2.65c-5.2-7.69-10.09-15.64-14.59-23.81l2.84-13.41-6.58 6.45c-30.23-58.13-42.61-126.63-25.28-189.32 19.73 2.27 38.88 4.12 57.39 5.62l50.35 211.82z"
        className="st0"
      />
      <path
        id="Layer_13"
        d="m1152.56 716.33.06.32h-.26c.11-.1.17-.2.2-.32z"
        className="st0"
      />
      <path
        id="Layer_12"
        d="M1117.1 717.41c-29.49-.26-48.07-2.71-48.07-2.71l50.34-211.82c12.93-.73 26.27-1.72 40-2.94 19.88 73.61-.39 154.65-42.27 217.47z"
        className="st0"
      />
      <path
        id="Layer_8"
        d="M1117.1 717.41c-34.73 52.16-84.36 91.77-138.15 104.12-11.43 6.48-23.72 9.99-36.55 9.99-13.6 0-26.62-3.96-38.62-11.2-52.19-13.57-100.32-52.38-134.54-102.97-5.2-7.69-10.09-15.64-14.59-23.81-1.28-2.3-2.52-4.6-3.73-6.96-30.23-58.13-42.61-126.63-25.28-189.32.19-.77.38-1.5.61-2.23 4.02-13.98 9.64-27.99 16.69-41.66 43.09-55.16 113.51-98.31 199.21-98.31h.45c85.29.16 155.32 43.16 198.51 98.34 7.6 14.65 13.57 29.72 17.75 44.66.16.64.35 1.24.51 1.88 19.88 73.61-.39 154.65-42.27 217.47z"
        className="st2"
      />
      <path
        id="Layer_7"
        d="M1117.1 717.41c-34.73 52.16-84.36 91.77-138.15 104.12-10.98 2.55-22.15 3.93-33.39 4.05-14.08.16-28.09-1.66-41.78-5.27-52.19-13.57-100.32-52.38-134.54-102.97-5.2-7.69-10.09-15.64-14.59-23.81-1.28-2.3-2.52-4.6-3.73-6.96-30.23-58.13-42.61-126.63-25.28-189.32.19-.77.38-1.5.61-2.23 4.02-13.98 9.64-27.99 16.69-41.66 35.69-69.17 108.34-129.5 199.59-129.34 90.97.19 162.76 60.39 198.57 129.37 7.6 14.65 13.57 29.72 17.75 44.66.16.64.35 1.24.51 1.88 19.89 73.62-.38 154.66-42.26 217.48z"
        className="st0"
      />
      <path
        id="Layer_4"
        d="M1051.44 658.62c0 75.14-30.23 139.11-72.49 162.92-11.43 6.48-23.72 9.99-36.55 9.99-13.6 0-26.62-3.96-38.62-11.2-41.18-24.71-70.42-87.81-70.42-161.71 0-95.5 48.81-172.91 109.04-172.91 60.24 0 109.04 77.4 109.04 172.91z"
        style={{
          fill: "#74e296",
        }}
      />
    </g>
    <g id="leg">
      <path
        d="M889.44 802.12h24.87v92.9h-24.87zM968.21 802.12h24.87v92.9h-24.87z"
        className="st0"
      />
      <path
        d="M914.307 895.017h-54.29v-24h54.29zM968.21 871.02h54.29v24h-54.29z"
        className="st0"
      />
    </g>
    <path
      id="w_1"
      d="M358.62 416.22c1.56 9.07 4.6 21.19 10.88 34.54a134.845 134.845 0 0 0 18.64 29.11c11.04 3.83 26.4 8.75 45.01 13.5 86.66 22.22 155.58 19.76 157.84 19.73-39.07 3-82.13 4.12-128.51 1.98a1026.73 1026.73 0 0 1-64.51-4.98c9.7 12.67 24.48 31.03 43.92 51.84 36.26 38.75 86.73 91.71 165.6 126.91 21.19 9.45 52.76 21.35 93.65 28.86l.41-.4c9.91-9.71 12.81-24.38 7.74-37.29-19.71-50.25-23.06-103.32-8.34-150.35 2.87-9.19 6.48-18.39 10.79-27.48-63.97-6.19-136.01-17.97-213.42-39.07a1284.521 1284.521 0 0 1-139.7-46.9z"
      className="st0"
    />
    <g id="glass">
      <path
        d="M1069.29 474.58c-3.02.02-22.71-.76-48.24-12.09-10.3-4.57-24.79-12.31-39.96-25.26-12.66 12.99-25.32 25.98-37.98 38.96l-37.51-39.97c-14.03 12.52-46.29 37.44-90.83 38.13-5.55.09-12.63-.24-22.02-1.73-55.41-8.78-96.17-53.71-96.98-106.86-.2-10.91-1.43-13.86-3.49-15.26-26.38-17.84-22.49-44.66-20.83-56.12l2.43-16.71h27.37c18.48-.08 37.01-.1 55.53-.11 27.24-.02 55.42-.05 83.16-.29.54-.01 1.13-.01 1.71-.01 50.6 0 75.94 25.53 88.56 49.35 4.22.14 8.46.2 12.65.2 3.92 0 7.89-.06 11.83-.18 17.07-32.33 47.15-49.37 87.44-49.37l1.69.01c14.63.2 29.51.2 43.91.2h98.52c2.33 0 4.29.23 5.87.42.74.09 1.57.19 1.93.19h7.53l11.63 10.54.54 7.85c.08 1.12.17 2.23.26 3.34 1.01 12.53 2.69 33.51-18.5 48.93-2.48 1.84-5.22 5.14-5.58 14.85-1.57 50.94-35.6 92.76-86.69 106.4l-.45.12c-3.56.86-7.23 1.75-11.13 2.46-3.88.7-6.93 1.06-8.35 1.22.03-.03-7.29.74-14.02.79z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        d="M1194.08 297.6c-2.9 0-5.35-.61-7.8-.61h-98.52c-14.71 0-29.42 0-44.13-.2-35.89-.4-60.63 13.94-74.22 44.24-.89 2.22-4.68 4.65-7.13 4.85-12.93.61-25.86.61-38.78 0-2.9 0-7.13-2.63-8.02-5.05-13.82-30.7-39.23-44.44-75.34-44.04-46.36.4-92.5.2-138.86.4H690.8c-2.23 15.35-1.56 27.67 12.48 37.17 10.7 7.27 11.81 19.19 12.04 31.11.67 44.24 34.55 80.6 80.46 87.87 49.26 7.68 92.28-14.54 110.55-57.17 2.45-5.45 4.9-11.31 8.47-16.16 7.36-9.9 18.28-14.95 31.65-13.74 13.15 1.21 22.51 8.08 27.64 19.39 2.9 6.46 5.13 12.93 8.25 19.19 17.39 33.94 58.17 54.34 98.96 49.49 2.23-.2 4.68-.61 6.91-1.01 3.34-.61 6.69-1.41 10.03-2.22 42.35-11.31 70.88-45.05 72.22-88.27.45-11.92 3.79-22.62 13.6-29.9 13.6-9.9 11.14-22.22 10.25-35.15l-.23-.19z"
        className="st2"
      />
      <path
        d="M900.53 369.71c-6.02 29.69-22.29 54.74-55.5 66.66-54.83 20-110.78-14.34-114.34-69.89-.45-8.48-.22-17.17 0-25.65.22-18.38 11.81-29.09 32.54-29.69 14.71-.4 29.64 0 44.36 0v-.4c12.48 0 25.19-.2 37.67 0 38.56.81 62.19 24.85 55.28 59.19v-.22zM1153.96 342.44c-.22 14.75-.22 29.9-4.23 44.04-6.46 22.83-23.63 40-45.69 48.88-4.23 1.62-8.47 3.03-12.93 4.04-4.9 1.21-9.81 1.82-14.93 2.22-35.44 2.42-66.2-14.34-81.8-44.64-8.02-15.76-13.37-31.92-8.92-49.69 5.57-22.02 24.07-36.16 49.04-36.76 13.6-.4 27.19 0 40.57 0h37.89c3.34 0 6.46.4 9.81.81 2.67.4 5.35.81 7.8 1.62 20.73 6.06 24.07 9.7 23.63 29.29l-.24.19z"
        className="st2"
      />
      <path
        id="path26_00000129918288420453683500000016620582088418526347_"
        d="M856.43 331.53h-23.4c-2.23 0-4.9 1.41-6.24 3.03-17.16 21.41-34.1 42.82-51.26 64.44-.22.4-.22 1.01 0 1.41 4.46 3.84 8.69 7.27 14.27 11.92.45.4 1.34.4 1.78 0 21.84-26.26 43.02-52.12 65.53-79.18.67-.61 0-1.62-.89-1.62h.21z"
        className="st5"
      />
      <path
        id="path28_00000044139142093698078490000018019492454389255076_"
        d="M1132.81 331.53h-23.4c-2.23 0-4.9 1.41-6.24 3.03-17.16 21.41-34.1 42.82-51.27 64.44-.22.4-.22 1.01 0 1.41 4.46 3.84 8.69 7.27 14.27 11.92.45.4 1.34.4 1.78 0 21.84-26.26 43.02-52.12 65.53-79.18.67-.61 0-1.62-.89-1.62h.22z"
        className="st5"
      />
      <path
        id="path36_00000183230378526556130970000016133162381862285226_"
        d="M943.71 404.69c-8.78 0-18.63 9.09-16.92 21.01l16.71 24.85c5.35-8.48 10.92-16.77 16.28-25.25 1.5-11.51-7.5-20.6-16.06-20.81v.2z"
        className="st0"
      />
    </g>
  </svg>
)
export default WorkOwlFullWigns
